// src/services/web3Service.js

import Web3 from 'web3';

const BSC_TESTNET_RPC = 'https://data-seed-prebsc-1-s1.binance.org:8545/';

// SINGLETON - Created ONCE, lives forever
class Web3Service {
  constructor() {
    this.web3 = null;
    this.isInitialized = false;
    this.initialize();
  }

  initialize() {
    if (this.isInitialized) return;
    
    console.log('🔵 Web3Service: Initializing...');
    this.web3 = new Web3(BSC_TESTNET_RPC);
    this.isInitialized = true;
    console.log('✅ Web3Service: Ready');
  }

  getWeb3() {
    return this.web3;
  }

  getContract(abi, address) {
    if (!this.web3) {
      console.error('❌ Web3 not initialized');
      return null;
    }
    return new this.web3.eth.Contract(abi, address);
  }

  async executeRead(contract, method, ...args) {
    if (!contract) throw new Error('Contract not initialized');
    return await contract.methods[method](...args).call();
  }

  async call(contract, method, ...args) {
    if (!contract) {
      throw new Error('Contract not initialized');
    }
    return await contract.methods[method](...args).call();
  }
}

// Export SINGLE instance
export default new Web3Service();